// React
import React, { useState } from "react";

// Components
import SecondaryButton from "../buttons/SecondaryButton";

const iconConfig = {
  delete: {
    containerClass: "delete-popup-bg",
    icon: (
      <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.5172 11.7795L16.26 11.8829L15.5172 11.7795ZM15.2549 13.6645L15.9977 13.7679L15.2549 13.6645ZM2.74514 13.6645L3.48798 13.5611L2.74514 13.6645ZM2.4828 11.7795L1.73996 11.8829L2.4828 11.7795ZM6.18365 20.7368L5.89206 21.4278L6.18365 20.7368ZM3.47508 17.5603L4.17907 17.3017L3.47508 17.5603ZM14.5249 17.5603L15.2289 17.819V17.819L14.5249 17.5603ZM11.8164 20.7368L11.5248 20.0458H11.5248L11.8164 20.7368ZM2.74664 7.92906C2.70746 7.5167 2.34142 7.21418 1.92906 7.25336C1.5167 7.29254 1.21418 7.65858 1.25336 8.07094L2.74664 7.92906ZM16.7466 8.07094C16.7858 7.65858 16.4833 7.29254 16.0709 7.25336C15.6586 7.21418 15.2925 7.5167 15.2534 7.92906L16.7466 8.07094ZM17 6.75C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25V6.75ZM1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75V5.25ZM6.25 17C6.25 17.4142 6.58579 17.75 7 17.75C7.41421 17.75 7.75 17.4142 7.75 17H6.25ZM7.75 9C7.75 8.58579 7.41421 8.25 7 8.25C6.58579 8.25 6.25 8.58579 6.25 9H7.75ZM10.25 17C10.25 17.4142 10.5858 17.75 11 17.75C11.4142 17.75 11.75 17.4142 11.75 17H10.25ZM11.75 9C11.75 8.58579 11.4142 8.25 11 8.25C10.5858 8.25 10.25 8.58579 10.25 9H11.75ZM13 6V6.75H13.75V6H13ZM5 6H4.25V6.75H5V6ZM14.7744 11.6761L14.512 13.5611L15.9977 13.7679L16.26 11.8829L14.7744 11.6761ZM3.48798 13.5611L3.22564 11.6761L1.73996 11.8829L2.0023 13.7679L3.48798 13.5611ZM9 20.25C7.47083 20.25 6.92544 20.2358 6.47524 20.0458L5.89206 21.4278C6.68914 21.7642 7.60558 21.75 9 21.75V20.25ZM2.0023 13.7679C2.282 15.7777 2.43406 16.9017 2.77109 17.819L4.17907 17.3017C3.91156 16.5736 3.77851 15.6488 3.48798 13.5611L2.0023 13.7679ZM6.47524 20.0458C5.55279 19.6566 4.69496 18.7058 4.17907 17.3017L2.77109 17.819C3.3857 19.4918 4.48205 20.8328 5.89206 21.4278L6.47524 20.0458ZM14.512 13.5611C14.2215 15.6488 14.0884 16.5736 13.8209 17.3017L15.2289 17.819C15.5659 16.9017 15.718 15.7777 15.9977 13.7679L14.512 13.5611ZM9 21.75C10.3944 21.75 11.3109 21.7642 12.1079 21.4278L11.5248 20.0458C11.0746 20.2358 10.5292 20.25 9 20.25V21.75ZM13.8209 17.3017C13.305 18.7058 12.4472 19.6566 11.5248 20.0458L12.1079 21.4278C13.5179 20.8328 14.6143 19.4918 15.2289 17.819L13.8209 17.3017ZM3.22564 11.6761C3.00352 10.08 2.83766 8.88703 2.74664 7.92906L1.25336 8.07094C1.34819 9.06897 1.51961 10.2995 1.73996 11.8829L3.22564 11.6761ZM16.26 11.8829C16.4804 10.2995 16.6518 9.06896 16.7466 8.07094L15.2534 7.92906C15.1623 8.88702 14.9965 10.08 14.7744 11.6761L16.26 11.8829ZM17 5.25H1V6.75H17V5.25ZM7.75 17V9H6.25V17H7.75ZM11.75 17V9H10.25V17H11.75ZM12.25 5V6H13.75V5H12.25ZM13 5.25H5V6.75H13V5.25ZM5.75 6V5H4.25V6H5.75ZM9 1.75C10.7949 1.75 12.25 3.20507 12.25 5H13.75C13.75 2.37665 11.6234 0.25 9 0.25V1.75ZM9 0.25C6.37665 0.25 4.25 2.37665 4.25 5H5.75C5.75 3.20507 7.20507 1.75 9 1.75V0.25Z"
          fill="#DC3545"
        />
      </svg>
    ),
  },
  danger: {
    containerClass: "bg-[#FEF2F2]",
    icon: (
      <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 1.75C10.7949 1.75 12.25 3.20507 12.25 5V6H13V17C13 18.932 11.432 20.5 9.5 20.5H8.5C6.568 20.5 5 18.932 5 17V6H5.75V5C5.75 3.20507 7.20507 1.75 9 1.75Z" stroke="#DC2626" strokeWidth="1.5" />
        <path d="M7.5 9.5V15.5" stroke="#DC2626" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M10.5 9.5V15.5" stroke="#DC2626" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  info: {
    containerClass: "bg-[#EEF2FF]",
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="7.5" stroke="#4F46E5" strokeWidth="1.5" />
        <path d="M9 8V12" stroke="#4F46E5" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="9" cy="6" r="0.75" fill="#4F46E5" />
      </svg>
    ),
  },
  success: {
    containerClass: "bg-[#ECFDF5]",
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99594 13.0041 1.75 9 1.75C4.99594 1.75 1.75 4.99594 1.75 9C1.75 13.0041 4.99594 16.25 9 16.25Z" stroke="#059669" strokeWidth="1.5" />
        <path d="M6.5 9.25L8.25 11L11.75 7.5" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
};

const ModalConfirm = ({
  type = "delete",
  title,
  text,
  children,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  contentRef,
}) => {

  const config = iconConfig[type] || iconConfig.delete;
  const handleConfirm = onConfirm;
  const [isLoading, setIsLoading] = useState(false);

  const onDelete = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
      <div ref={contentRef} className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
        <div className="flex mt-2 text-sm items-center">
          <span className={`${config.containerClass} item-centers p-4 rounded-full`}>
            {config.icon}
          </span>
          <span className="font-mont text-[16px] flex-auto wrap-text-style">
            {children || title || (
              <>
                Are you sure you want to delete <b>{text}</b>?
              </>
            )}
          </span>
        </div>
        <div className="flex flex-row justify-end gap-5 mt-5">
          <button
            disabled={isLoading}
            className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 red_btn disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleConfirm}
          >
            {confirmLabel}
          </button>

          <SecondaryButton
            onClick={onCancel}
            label={cancelLabel}
            classes={"px-5 py-3"}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;
